<template>
  <ModalDefault modal_id="showReportModal"
                size="modal-lg"
                header="y"
                :modal_header="getLeadObject('id', getTicketObject('id', histories.history.ticket_id).lead_id).name"
                icon="bx bx-link-external"
                class_header=""
                :style_top_header="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; top: 0; width: 100%; z-index: 999;' : ''"
                :style_footer="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; bottom: 0; width: 100%; z-index: 999;' : ''"
                class_footer="border-top"
                :lead_id="getTicketObject('id', histories.history.ticket_id).lead_id"
                class_body="p-0 "
                footer="">
    <div slot="body" :style="($mq === 'mobile' || $mq === 'tablet') ? 'padding-top: 110px;' : ''">
      <div :style="($mq === 'mobile' || $mq === 'tablet') ? 'min-height: 85vh;' : 'min-height: 410px; max-height: 410px;'"
           style="overflow-y: auto;"
           class="card-body">
          <div id="chat_conversation_report"
               class="chat_conversation px-2"
               :class="($mq === 'mobile' || $mq === 'tablet') ? 'mb-4 pb-5' : 'pb-1'">
            <ChatBalloonDefault class="animated--grow-in"
                               v-if="histories.history && histories.history.id"
                               :history="histories.history"/>
          </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import ChatBalloonDefault from "../../components/chat/ChatBalloonDefault";
import VueSlickCarousel from 'vue-slick-carousel'

export default {
  name: "ModalShowReport",
  components: {
    ModalDefault,
    ChatBalloonDefault,
    VueSlickCarousel
  },
  computed: {
    ...mapState(['users', 'tickets', 'me', 'configs', 'histories']),
    ...mapGetters([
        'getLeadObject',
        'getTicketObject',
    ]),
  },
  methods: {
    openUrl(payload){
      window.open(payload, "_blank");
    },
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>
<style scoped>

</style>
